import React from 'react';
import { getChannelColors } from '../../platewells/PlateDataWrangling';
import Spinner from '../Spinner';
import { useChannels, useShowGraph, usePlateWellActions } from '../../../store/plateWellStore';
const RenderChannelData = () => {

    const { setChannelVisibility, toggleShowGraph } = usePlateWellActions();
    const channels = useChannels();
    const showGraph = useShowGraph();

    const handleCheckboxChange = (name) => {
        setChannelVisibility(name);
    }


    return (
        channels?.length > 0 ?
            <div className='plate-control'>
                <h6 className='pb-4'>Flurophore</h6>
                <div className='space-y-2'>
                    {channels.map(({ name, visible }) => (
                        <div key={crypto.randomUUID()} className="flex items-center space-x-2">
                            <span className={`w-6 h-6 ${getChannelColors(name)} rounded-full`} />
                            <input
                                type="text"
                                value={name}
                                readOnly
                                className="border border-gray-300 rounded px-2 py-1 text-sm w-16"
                            />
                            <label key={crypto.randomUUID()}>
                                <input
                                    type="checkbox"
                                    checked={visible}
                                    onChange={() => handleCheckboxChange(name)}
                                /> Show {name}
                            </label>
                        </div>
                    ))}
                </div>
                <div className='space-y-2 pt-2 pb-2'>

                    <label>
                        <input
                            type="checkbox"
                            checked={showGraph}
                            onChange={toggleShowGraph}
                        /> Show 2D Graph
                    </label>
                </div>


            </div>

            : <Spinner text="Loading channels..." />
    )
}

export default RenderChannelData;